// Global Instructions Rule Applied!
//
// The warning a rendered report carries when it prints agent-written company
// short descriptions nobody has signed off yet (owner, 2026-11-03), beside
// the highlights review chip and in its vocabulary: gold = needs attention.
// Nothing renders when every printed description is a person's or signed off.
import React from 'react'
import { Tag, Tooltip } from 'antd'

export const DescriptionsReviewStatus: React.FC<{ unreviewed: string[] }> = ({ unreviewed }) => {
  if (unreviewed.length === 0) return null
  const plural = unreviewed.length === 1 ? '' : 's'
  return (
    <Tooltip
      title={`This report prints the agent-written short description${plural} of ${unreviewed.join(', ')}, not yet signed off. Open the company, read the Short Description on its Details tab, and press Sign off (or edit it).`}
    >
      <Tag color='gold'>
        {unreviewed.length} description{plural} not signed off
      </Tag>
    </Tooltip>
  )
}

export default DescriptionsReviewStatus
